export function isInvalidNumber(value: number | null | undefined): boolean {
  return value === null || value === undefined || Number.isNaN(value);
}

export function formatCurrency(value: number | null | undefined): string {
  if (isInvalidNumber(value)) return '—';
  if (value === 0) return '0';
  if (value! < 0) return `(${Math.abs(value!).toLocaleString()})`;
  return value!.toLocaleString();
}

export function formatMetricPercent(value: string | null | undefined): string {
  return value != null && value !== '' ? `${value}%` : '—';
}

export function formatMetricMultiplier(value: string | null | undefined): string {
  return value != null && value !== '' ? `${value}x` : '—';
}
